// cleanup_remove_external_libraries_CHECKFREE

import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';

import { memoizeWithToken } from 'api/utils/memoizeUtils';
import { DATE_FORMAT } from 'constants.js';

// Get the user permissions
export const getEnrollmentStatus = () => {
  return from(axios.get('/infrastructure/checkfree/permissions')).pipe(map(({ data }) => data));
};

// Get the enrolled bill pay accounts
export const getCheckfreeBankAccountList = () => {
  return from(axios.get('/infrastructure/checkfree/smallBusinessBankAccounts')).pipe(
    map(({ data }) => data)
  );
};

// Get the billingAccountEnabled flag
export const getBillingAccountEnabled = memoizeWithToken(() =>
  from(axios.get('/infrastructure/checkfree/billingAccountEnabled')).pipe(map(({ data }) => data))
);

export const getAccountManagementEnabled = memoizeWithToken(() =>
  from(axios.get('/infrastructure/checkfree/accountManagementEnabled')).pipe(
    map(({ data }) => data)
  )
);

// Get the list of available premier accounts
export const getPremierBankAccountsList = () => {
  return from(axios.get('/infrastructure/checkfree/accounts')).pipe(map(({ data }) => data));
};

// Add bill pay account to checkfree
export const addBillPayAccount = (payload) => {
  return from(axios.post('/infrastructure/checkfree/smallBusinessBankAccount', payload)).pipe(
    map(({ data }) => data)
  );
};

// Modify the bill pay fee account
export const modifyBillPayFeeAccount = (payload) => {
  return from(axios.put('/infrastructure/checkfree/smallBusinessBankAccount', payload)).pipe(
    map(({ data }) => data)
  );
};

// Deactivate account
export const deactivateBillPayAccount = (accountId) => {
  return from(
    axios.delete(`/infrastructure/checkfree/smallBusinessBankAccount/${accountId}`)
  ).pipe(map(({ data }) => data));
};

// Get the list of enrolled Checkfree users
export const getCheckfreeUsers = (userCode) => {
  const searchBy = userCode
    ? `searchBy=USER_CODE&userCode=${userCode}`
    : 'searchBy=ALL_USERS&userStatus=ACTIVE';
  return from(axios.get(`/infrastructure/checkfree/smallBusinessUsers?${searchBy}`)).pipe(
    map(({ data }) => data)
  );
};

// Get the list of Premier users
export const getPremierUsers = () => {
  return from(axios.get('/infrastructure/checkfree/premierUsers?action=Add')).pipe(
    map(({ data: { data } }) => data)
  );
};

// Get the list of enrollable Authorization Levels
export const getAuthorizationLevels = () => {
  return from(axios.get('/infrastructure/checkfree/authorizationLevels')).pipe(
    map(({ data: { data } }) => data)
  );
};

// Get add/modify user payload from user management form data
const getUserManagementPayload = (formData) => {
  const { authorizationLevel, dateOfBirth, taxId, userAccount } = formData;
  return {
    userCode: userAccount?.[0]?.id,
    authorizationLevel: authorizationLevel?.[0]?.id,
    dateOfBirth: moment(dateOfBirth?.[0]).format(DATE_FORMAT),
    taxId
  };
};

// Add Premier user to checkfree
export const addUserToBillPay = (formData) => {
  const payload = getUserManagementPayload(formData);
  return from(axios.post('/infrastructure/checkfree/smallBusinessUser', payload)).pipe(
    map(({ data }) => data)
  );
};

// Modify checkfree user
export const modifyBillPayUser = (formData) => {
  const payload = getUserManagementPayload(formData);
  return from(axios.put('/infrastructure/checkfree/smallBusinessUser', payload)).pipe(
    map(({ data }) => data)
  );
};

// Unregister checkfree user
export const unregisterBillPayUser = (userCode) => {
  return from(axios.delete(`/infrastructure/checkfree/smallBusinessUser/${userCode}`)).pipe(
    map(({ data }) => data)
  );
};
